import login from './sectors/login'
import partners from './sectors/partners'
import events from "./sectors/events";
import depts from "./sectors/depts";
import issues from "./sectors/issues";
import projects from "./sectors/projects";
import branches from "./sectors/branches"
import publicEndpoints from "@/wl-core/api/sectors/publicEndpoints";
import misc from "@/wl-core/api/sectors/misc";

export default {
    login:login,
    partners:partners,
    events:events,
    depts:depts,
    issues:issues,
    projects:projects,
    branches:branches,
    publicEndpoints:publicEndpoints,
    misc:misc
}

